module.exports = __webpack_public_path__ + "static/media/g-icon-arrow_down.b330e62f.svg";